<mat-form-field>
  <input (ngModelChange)="changeValue($event)" [ngModel]="rule.value" matInput type="text">
</mat-form-field>
